import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../../assets/saas/atoms/_checkbox.scss";
const Checkbox = ({ id, label, value, onChange, checked, }) => {
    const handleChange = () => {
        onChange(!checked);
    };
    return (_jsxs("div", { className: "checkbox", children: [_jsx("input", { className: "checkbox__input", id: id, type: "checkbox", value: value, onChange: handleChange, checked: checked, "aria-label": "checkbox" }), _jsx("label", { htmlFor: id, children: label })] }));
};
export default Checkbox;
